
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4e6b15b2&scoped=true!postcss!sass!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ReleaseSoloProtocol.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReleaseSoloProtocol.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-4e6b15b2!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReleaseSoloProtocol.vue"),
  /* scopeId */
  "data-v-4e6b15b2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/components/ReleaseSoloProtocol.vue
// module id = 1008
// module chunks = 0